export default __webpack_public_path__ + "static/media/4.d066480c.jpg";